import React from 'react';
import { Box } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CustomButton from '../../../../components/buttons/CustomButton';

const NavigationButtons = ({ activeTab, setActiveTab }) => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', marginTop: '32px' }}>
      <CustomButton
        style="primary"
        variant="outlined"
        label="Voltar"
        icon={<ArrowBackIcon />}
        onClick={() => setActiveTab(prev => Math.max(0, prev - 1))}
      />
      
      {activeTab < 2 && (
        <CustomButton
          style="secondary"
          variant="contained"
          label="Próximo"
          icon={<ArrowForwardIcon />}
          onClick={() => setActiveTab(prev => Math.min(2, prev + 1))}
        />
      )}
    </Box>
  );
};

export default NavigationButtons;